$(document).ready(function(){

	var _keys = $('.js-upgrade-footer');
	if (_keys.length < 1) {
		return;
	}

	var _key = 0;
	var ckey;
	var $productSelection = $('input[name="product_id"]');


	$productSelection.prop('disabled', true);
	$('#category_id_6').find('input[name="product_id"]').prop('disabled', false);

	$('.js-key-append').on('click', function (e) {
		e.preventDefault();

		_key += 1;
		var idv = 'act-key-'+_key;

		ckey = $('.js-field-template')
			.clone()
			.removeClass('is-hidden')
			.removeClass('js-field-template')
			.appendTo(_keys);
		ckey.attr('id', idv);
		ckey.find('.js-key-remove').attr('data-id', idv);
		ckey.find('input[name="license_key[]"]').prop('disabled', false);

		return false;
	});

	$('body').on('click', '.js-key-remove', function () {
		var el = $('#'+$(this).data('id'));
		el.remove();

		return false;
	});

	$('.js-select-category').on('change', function (e) {
		var $upgradeBlock =  $('#category_id_' + $(this).val());
		$productSelection.prop('disabled', true);
		$upgradeBlock.find('input[name="product_id"]').prop('disabled', false);
		$('.js-upgrade-category').hide();
		$upgradeBlock.fadeIn();
	});

	$('.js-change-upgrade-page').on('change', function (e) {
		var _base_url = $('#upgrade-form').attr('action');
		var _alias =  $(this).val();

		if (_base_url.charAt(_base_url.length-1) == '/') {
			_base_url = _base_url.substr(0,_base_url.length-1);
		}

		var _url = _base_url + '/' + _alias + '/';
		location.href=_url;
	});

	/* Upgrade form */
	var $upgradeSection = $('#upgrade_section');

	$('#upgrade-form').submit(function(e) {
		var $form = $(this);

		if ($form.hasClass('working')) {
			return false;
		}
		$form.addClass('working');

		$.ajax({
			type: $form.attr('method'),
			url: $form.attr('action'),
			data: $form.serialize()
		}).done(function(response) {
			var result = jQuery.parseJSON(response);
			if (result.status) {
				$upgradeSection.html($('#upgrade_form_positive_result').html());
				$(document).scrollTop(0);
			} else if (result.errors) {
				$('.js-upgrade_form__error').empty();

				var errors = result.errors;
				$.each(errors, function(key, value) {
					$('.js-upgrade_form__error').html();

					var $errorField = $('.js-upgrade_form__error_' + key);
					$errorField.css({"color": "red", 'font-size': "0.8em"});
					$errorField.html(value);
				});

				$form.removeClass('working');
			} else  {
				$upgradeSection.html($('#upgrade_form_negative_result').html());
				$(document).scrollTop(0);
			}
		}).fail(function() {
			$upgradeSection.html($('#upgrade_form_negative_result').html());
			$(document).scrollTop(0);
		});

		e.preventDefault();
	});

	function scroolToUpgradeSection() {
		var scrollTop = $upgradeSection.offset().top - 100;
		$(document).scrollTop(scrollTop);
	}

	/* /Upgrade form */
});
